import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ICardRoot } from 'src/app/_types/card.types';
import { IError, IResponse } from 'src/app/_types/common.types';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotifierService } from 'src/app/shared/services/notifier.service';
import { CompanyDetailFormComponent } from './company-detail-form/company-detail-form.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { PlanSelectionFormComponent } from './plan-selection-form/plan-selection-form.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  @ViewChild(CompanyDetailFormComponent)
  companyDetailFormComponent!: CompanyDetailFormComponent;
  @ViewChild(PlanSelectionFormComponent)
  planSelectionFormComponent!: PlanSelectionFormComponent;
  @ViewChild(PaymentFormComponent) paymentFormComponent!: PaymentFormComponent;
  @ViewChild(MatStepper) matStepper!: MatStepper;

  companyDetailForm!: FormGroup;
  planSelectionForm!: FormGroup;
  paymentForm!: FormGroup;

  private unsubscribe$ = new Subject<void>();

  // Define an array to hold the image paths for each step
  // stepImages: string[] = [
  //   '/assets/images/registration-bg.svg',
  //   '/assets/images/register.png', // Company Info
  //   '/assets/images/plan-form.png', // Select Plan
  //   '/assets/images/payment-form.png', // Start Trial
  // ];

  featureLists: string[][] = [
    [
      'Unlimited usage of the route planner',
      'No minimum contract commitment',
      'Add and/or remove drivers online at your convenience',
    ],
    [
      'All your drivers get full access right away.',
      'Give your drivers the best chance of finding their destination and you’ll make your customers happier.',
      'Delm8 route planner makes your drivers better at their job',
      'You can cancel anytime',
    ],
    [
      'You won’t be charged if you cancel within the 14 days free trial.',
      '<div class=\"raw-html-embed\"><p>After that you will automatically be charged in advance per driver on a <strong>Rolling contract <i>Cancel Anytime</i></strong>.</p></div>',
      'The actual cost will depend on your chosen package.',
    ],
  ];

  stepImages: number[] = [0, 1, 2];

  // Variable to hold the current image path based on the current step
  currentImagePath: number = 0; // Initialize with the image for the first step

  constructor(
    private _FormBuilder: FormBuilder,
    private _AuthService: AuthService,
    public router: Router,
    private _NotifierService: NotifierService,
    private _LoaderService: LoaderService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.companyDetailForm = this.companyDetailFormComponent.form;
    this.planSelectionForm = this.planSelectionFormComponent.form;
    this.paymentForm = this.paymentFormComponent.form;
  }

  get companyDetailFormGroup(): FormGroup {
    return this.companyDetailFormComponent
      ? this.companyDetailFormComponent.form
      : this._FormBuilder.group({});
  }

  get planSelectionFormGroup(): FormGroup {
    return this.planSelectionFormComponent
      ? this.planSelectionFormComponent.form
      : this._FormBuilder.group({});
  }

  get paymentFormGroup(): FormGroup {
    return this.paymentFormComponent
      ? this.paymentFormComponent.form
      : this._FormBuilder.group({});
  }

  registerUser(cardDataWithToken: ICardRoot) {
    if (
      this.companyDetailForm.valid &&
      this.planSelectionForm &&
      this.paymentForm
    ) {
      const {
        email,
        password,
        company_name,
        first_name,
        last_name,
        telephone_number,
        number_of_drivers,
        industry,
      } = this.companyDetailForm.value;
      const { planId: plan_id } = this.planSelectionForm.value;
      const { address1, address2, postcode, city } = this.paymentForm.value;

      const registrationRequestPayload = {
        email,
        password,
        company_name,
        first_name,
        last_name,
        telephone_number,
        number_of_drivers: number_of_drivers ? number_of_drivers : 0,
        industry,
        plan_id,
        address1,
        address2,
        postcode,
        city,
        card: {
          token: cardDataWithToken.id,
          brand: cardDataWithToken.card.brand,
          lastFourDigits: cardDataWithToken.card.last4,
          cardHolderName: cardDataWithToken.card.name,
        },
      };
      this._LoaderService.setState(true);
      this._AuthService
        .onlineCorporateRegistration(registrationRequestPayload)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (response: IResponse) => {
            if (response.success === true) {
              this._LoaderService.setState(false);
              this._NotifierService.showSuccess(response.message);

              this.router.navigate(['/login']);
            }
          },
          error: (error: IError) => {
            console.log('inside error=====>>', error);
            this._NotifierService.showError(error?.message ?? error.error?.message);
          },
        });
    }
  }

  // Method to handle step change event
  onStepChange(index: number) {
    // Update the current image path based on the current step
    this.currentImagePath = index;
  }
}
